import { useCallback, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./AboutUs.scss";
import Image from "react-bootstrap/Image";
import laptopbig from "../../assets/images/laptopLoc.png";
import AboutUsMission from "../../assets/images/AboutUsMission.png";
import AboutUsFeature1 from "../../assets/images/AboutUsFeature1.svg";
import AboutUsFeature2 from "../../assets/images/AboutUsFeature2.svg";
import AboutUsFeature3 from "../../assets/images/AboutUsFeature3.svg";
import AboutUsFeature4 from "../../assets/images/AboutUsFeature4.svg";
import AboutUsServices from "../../assets/images/AboutUsServices.png";
import AboutUsStory from "../../assets/images/AboutUsStory.png";

import { getCounterInBanner, getPageContent } from "../../api/apiRequest";
import { NotificationManager } from "react-notifications";
import { useLangContext } from "../../context/languageContext";
import { Tag } from "../../utils/GTMPageTag";

const AboutUs = () => {
  Tag("AboutUs")
  const { hostLanguage } = useLangContext();
  const [counterDetails, setCounterDetails] = useState([]);
  const [contentDetails, setContentDetails] = useState();

  // get page content
  const getAllPageContent = useCallback(async () => {
    try {
      let apiRes = await getPageContent(hostLanguage, "aboutUs_page_data");
      let responseData = await apiRes.json();
      if (responseData.res) {
        setContentDetails(responseData.data);
      } else {
        console.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  }, [hostLanguage]);

  // get banner counter information
  const getBannerCounterInfo = async () => {
    try {
      let apiRes = await getCounterInBanner();
      let responseData = await apiRes.json();
      if (responseData.res) {
        setCounterDetails(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllPageContent();
    getBannerCounterInfo();
  }, [getAllPageContent]);

  return (
    <div id="AboutUs" className="MainbBody">
      <div className="AboutBannerScetion">
        <div className="BannerScetionTop">
          <Container className="">
            <Row>
              <Col sm={12}>
                <div dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.banner_text }}></div>
                <h3 dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.title }}></h3>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="BannerScetionBottom BannerScetionBottomAbout">
        <Container className="">
          <Row className="justify-content-md-center">
            <Col sm={12} md={3}>
              <div className="BannerScetionBottomBox">
                <h4>{contentDetails?.aboutUs_page_data?.banner_below_text?.text_1}</h4>
                <p>
                  {counterDetails?.company_foundation}+ {contentDetails?.aboutUs_page_data?.banner_below_text?.last_text}
                </p>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="BannerScetionBottomBox ">
                <h4>{contentDetails?.aboutUs_page_data?.banner_below_text?.text_2}</h4>
                <p>
                  {counterDetails?.customer_foundation}+ {contentDetails?.aboutUs_page_data?.banner_below_text?.last_text}
                </p>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="BannerScetionBottomBox ">
                <h4>{contentDetails?.aboutUs_page_data?.banner_below_text?.text_3}</h4>
                <p>
                  {counterDetails?.number_world_wide}+ {contentDetails?.aboutUs_page_data?.banner_below_text?.last_text}
                </p>
              </div>
            </Col>
            <Col sm={12} md={3}>
              <div className="BannerScetionBottomBox last-child">
                <h4>{contentDetails?.aboutUs_page_data?.banner_below_text?.text_4}</h4>
                <p>
                  {counterDetails?.register_agents}+ {contentDetails?.aboutUs_page_data?.banner_below_text?.last_text}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="InfoScetion">
        <Container className="InfoScetionContainer">
          <Row className="align-items-center">
            <Col sm={12} md={6}>
              <div className="InfoScetionLft">
                <div dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description1 }}></div>
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className="InfoScetionRgt">
                <Image src={laptopbig} className="laptopbig" alt="LaptopBig" fluid />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="DigitalmailboxScetion">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="DigitalmailboxScetionInner">
                <Row className="align-items-center">
                  <Col sm={12} md={7}>
                    <div 
                      className="DigitalmailboxinLft DigitalmailboxinLftp"
                      dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description2 }}>
                  </div>
                  </Col>
                  <Col sm={12} md={5}>
                    <div className="DigitalmailboxinRgt">
                      <Image src={AboutUsMission} className="BoxImg w-100" alt="BoxImg" />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="FourBoxScetion">
        <Container className="">
          <Row>
            <Col sm={12} md={3}>
              <div className="FourBoxScetionBox">
                <span>
                  {" "}
                  <Image src={AboutUsFeature1} className="BannerImg" alt="BannerImg" fluid />
                </span>

                <div dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description3 }}></div>
              </div>
            </Col>

            <Col sm={12} md={3}>
              <div className="FourBoxScetionBox">
                <span>
                  {" "}
                  <Image src={AboutUsFeature2} className="BannerImg" alt="BannerImg" fluid />
                </span>

                <div dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description4 }}></div>
              </div>
            </Col>

            <Col sm={12} md={3}>
              <div className="FourBoxScetionBox">
                <span>
                  {" "}
                  <Image src={AboutUsFeature3} className="BannerImg" alt="BannerImg" fluid />
                </span>

                <div dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description5 }}></div>
              </div>
            </Col>

            <Col sm={12} md={3}>
              <div className="FourBoxScetionBox">
                <span>
                  {" "}
                  <Image src={AboutUsFeature4} className="BannerImg" alt="BannerImg" fluid />
                </span>

                <div dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description6 }}></div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="AboutInfoScetion">
        <Container className="">
          <Row>
            <Col sm={12} md={6}>
              <div className="AboutInfoScetionLft" dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description7 }}></div>
            </Col>
            <Col sm={12} md={6}>
              <Image src={AboutUsServices} className="BoxImg" alt="BoxImg" fluid />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="AboutInfoScetion2">
        <Container className="">
          <Row>
            <Col sm={12} md={6}>
              <Image src={AboutUsStory} className="BoxImg" alt="BoxImg" fluid />
            </Col>
            <Col sm={12} md={6}>
              <div className="AboutInfoScetionLft" dangerouslySetInnerHTML={{ __html: contentDetails?.aboutUs_page_data?.description8 }}></div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AboutUs;
